/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Faq_9_QInputs */

const en_vc_faq_9_q = /** @type {(inputs: Vc_Faq_9_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is this the official VectorCraft website?`)
};

const zh_vc_faq_9_q = /** @type {(inputs: Vc_Faq_9_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是 VectorCraft 的官方网站吗？`)
};

/**
* | output |
* | --- |
* | "Is this the official VectorCraft website?" |
*
* @param {Vc_Faq_9_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_faq_9_q = /** @type {((inputs?: Vc_Faq_9_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Faq_9_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_faq_9_q(inputs)
	return zh_vc_faq_9_q(inputs)
});
export { vc_faq_9_q as "vc.faq.9.q" }